import React, { Dispatch, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Channels,
  Events,
  listen,
} from '@npm-client-frontends/client-frontends-custom-events'
import {
  useUserAuthSession,
  AuthSessionState,
} from '@npm-client-frontends/global-context'

export const AuthListener = ({
  setAuthChecked,
}: {
  setAuthChecked: Dispatch<React.SetStateAction<boolean>>
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { sessionState } = useUserAuthSession()

  useEffect(() => {
    const removeListener = listen(Channels.AUTH, (event) => {
      if (event.detail.event === Events.USER_AUTHENTICATED) {
        navigate(event.detail.data as string)
        window.location.reload()
      }

      if (event.detail.event === Events.USER_UNAUTHENTICATED) {
        navigate(event.detail.data as string)
      }

      if (event.detail.event === Events.LOGOUT) {
        navigate('/login')
      }
    })

    return () => {
      removeListener()
    }
  }, [])

  useEffect(() => {
    if (
      sessionState !== null &&
      sessionState !== undefined &&
      sessionState !== AuthSessionState.Loading
    ) {
      if (sessionState === AuthSessionState.Loaded) {
        if (location.pathname === '/login') {
          navigate('/')
        }
      } else if (sessionState === AuthSessionState.Error) {
        if (location.pathname !== '/login') {
          sessionStorage.setItem('preLoginRoute', location.pathname)
          navigate('/login')
        }
      }
      setAuthChecked(true)
    }
  }, [sessionState])

  return null
}
